import React from 'react';

function Intro() {
  return (
    <section className="page-intro section-padding pb-0">
      <div className="container">
        <div className="row md-marg">
          <div className="col-lg-6">
            <div className="img md-mb80">
              <div className="row">
                <div className="col-6">
                  <img src="/assets/imgs/intro/i1.jpg" alt="" />
                  <div className="img-icon">
                    <img src="/assets/imgs/arw0.png" alt="" />
                  </div>
                </div>
                <div className="col-6 mt-40">
                  <img src="/assets/imgs/intro/i2.jpg" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 valign">
            <div className="cont">
              <h3 className="mb-30">
                Kanus Digital, güzel{' '}
                <span className="fw-200">dijital deneyimler</span> ve
                ürünler yaratan tam kapsamlı bir{' '}
                <span className="fw-200">dijital ajansdır.</span>
              </h3>
              <p>
                Tasarım hizmetlerimiz, markaları güçlendiren uçtan uca bir
                deneyim stratejisiyle başlar ve biter. İşletmenizi dijital
                dünyada öne çıkaracak web siteleri, uygulamalar ve pazarlama
                çözümleri sunuyoruz.
              </p>
              <a href="/page-services" className="underline main-color mt-40">
                <span className="text">
                  Hizmetlerimiz <i className="ti-arrow-top-right"></i>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Intro;
